"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLogRecord = void 0;
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
var mapHelpers_1 = require("../../../utils/mapHelpers");
var timeConverter_1 = require("../../../utils/timeConverter");
var bluetooth_codes_map_1 = __importDefault(require("../maps/bluetooth-codes.map"));
var event_types_map_1 = __importDefault(require("../maps/event-types.map"));
var lock_code_map_1 = __importDefault(require("../maps/lock-code.map"));
var power_codes_map_1 = __importDefault(require("../maps/power-codes.map"));
var error_codes_map_1 = __importDefault(require("../maps/error-codes.map"));
var addEventDataToLogRecord = function (logRecord, data) {
    if (['Boot', 'Battery', 'Bluetooth'].includes(logRecord.eventType)) {
        try {
            switch (logRecord.eventType) {
                case 'Boot':
                    logRecord.eventData = {
                        fwVerMsb: data === null || data === void 0 ? void 0 : data.getUint8(10),
                        fwVerLsb: data === null || data === void 0 ? void 0 : data.getUint8(11),
                        boardId: data === null || data === void 0 ? void 0 : data.getUint16(12),
                    };
                    break;
                case 'Battery':
                    logRecord.eventData = {
                        batteryPercentage: data === null || data === void 0 ? void 0 : data.getUint8(10),
                        thermalResLow: !!(data === null || data === void 0 ? void 0 : data.getUint8(11)),
                        thermalResHigh: !!(data === null || data === void 0 ? void 0 : data.getUint8(12)),
                    };
                    break;
                case 'Bluetooth':
                    if (logRecord.eventCode === 'Pairing Failed') {
                        logRecord.eventData = {
                            failedReason: data === null || data === void 0 ? void 0 : data.getUint8(10),
                        };
                    }
                    break;
                default:
                    break;
            }
        }
        catch (e) {
            logRecord.eventData = {
                error: 'Impossible to parse data',
            };
        }
    }
    return logRecord;
};
var parseLogRecord = function (data, device) { return __awaiter(void 0, void 0, void 0, function () {
    var getEventCode, startOfFile, endOfFile, adjustedTimeStamp, timestamp, logRecord, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                getEventCode = function (eventType, eventCode) {
                    switch (eventType) {
                        case 0:
                            return 'N/A';
                        case 1:
                            return (0, mapHelpers_1.getMapValue)(power_codes_map_1.default, eventCode);
                        case 2:
                            return (0, mapHelpers_1.getMapValue)(error_codes_map_1.default, eventCode);
                        case 3:
                            return 'N/A';
                        case 4:
                            return (0, mapHelpers_1.getMapValue)(lock_code_map_1.default, eventCode);
                        case 5:
                            return (0, mapHelpers_1.getMapValue)(bluetooth_codes_map_1.default, eventCode);
                        default: {
                            // return eventType;
                            throw new Error('No event type with provided code');
                        }
                    }
                };
                startOfFile = data && data.byteLength.valueOf() === 8;
                endOfFile = data && data.byteLength.valueOf() === 4;
                if (startOfFile) {
                    return [2 /*return*/, {
                            startOfFile: data === null || data === void 0 ? void 0 : data.getUint32(0),
                            count: data === null || data === void 0 ? void 0 : data.getUint32(1),
                        }];
                }
                if (endOfFile) {
                    return [2 /*return*/, {
                            endOfFile: data === null || data === void 0 ? void 0 : data.getUint32(0),
                        }];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, timeConverter_1.adjustDate)(1000 * (data === null || data === void 0 ? void 0 : data.getUint32(4)), device)];
            case 2:
                adjustedTimeStamp = _a.sent();
                timestamp = (0, timeConverter_1.timeConverter)(adjustedTimeStamp).toString();
                logRecord = {
                    logIndex: data === null || data === void 0 ? void 0 : data.getUint32(0),
                    timestamp: data && timestamp,
                    eventType: data ? (0, mapHelpers_1.getMapValue)(event_types_map_1.default, data === null || data === void 0 ? void 0 : data.getUint8(8)) : 'N/A',
                    eventCode: data ? getEventCode(data === null || data === void 0 ? void 0 : data.getUint8(8), data === null || data === void 0 ? void 0 : data.getUint8(9)) : 'N/A',
                };
                return [2 /*return*/, addEventDataToLogRecord(logRecord, data)];
            case 3:
                e_1 = _a.sent();
                console.log(e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.parseLogRecord = parseLogRecord;
